firebird.factory('storageService', [
    '$window',
    'helperService',
    function ($window, helperService) {
        var service = {
            set: set,
            get: get,
            remove: remove,
            clearTimedKeys: clearTimedKeys,
            clearTimedKeyOlderThanDays: clearTimedKeyOlderThanDays
        };

        return service;

        ////////////////////////

        function set(key, val) {
            if (
                key === 'using-phone-for-audio' &&
                (helperService.getQueryParameter('audio') === 'computer' ||
                    helperService.getQueryParameter('audio') === 'phone')
            ) {
                // Don't set local storage
                return false;
            } else {
                return $window.localStorage.setItem(key, val);
            }
        }

        function get(key) {
            var value = $window.localStorage.getItem(key);
            if (value === 'false') {
                return false;
            } else if (value === 'true') {
                return true;
            } else if (value === 'null') {
                return null;
            } else {
                return value;
            }
        }

        function remove(key) {
            return $window.localStorage.removeItem(key);
        }

        function clearTimedKeys() {
            var timedKeys = ['logged-in-meeting', 'prepop-meeting'];

            timedKeys.forEach(function (key) {
                $window.localStorage.removeItem(key);
            });
        }

        function clearTimedKeyOlderThanDays(key, days) {
            var currentDate = new window.moment();
            var value = JSON.parse(window.localStorage.getItem(key));
            if (value && value.createdDate) {
                var createdDate = new window.moment(value.createdDate);
                var futureDate = createdDate.add('days', days);
                if (currentDate.diff(futureDate, 'day') >= 0) {
                    window.localStorage.removeItem(key);
                }
            }
        }
    }
]);
